import { tokens } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
export var getBlogCardWidgetStyles = (isLargeScreen, props) => {
  var heightConfig = props.heightConfig,
    _props$imageHeightCon = props.imageHeightConfig,
    imageHeightConfig = _props$imageHeightCon === void 0 ? {
      desktop: 176,
      mobile: 152
    } : _props$imageHeightCon;
  return StyleSheet.create({
    card: Object.assign(Object.assign({}, heightConfig && {
      height: isLargeScreen ? heightConfig === null || heightConfig === void 0 ? void 0 : heightConfig.desktop : heightConfig === null || heightConfig === void 0 ? void 0 : heightConfig.mobile
    }), {
      overflow: 'hidden'
    }),
    blogImage: Object.assign({
      borderTopLeftRadius: tokens.borderRadius.BORDER_RADIUS_16,
      borderTopRightRadius: tokens.borderRadius.BORDER_RADIUS_16
    }, imageHeightConfig && {
      minHeight: isLargeScreen ? imageHeightConfig === null || imageHeightConfig === void 0 ? void 0 : imageHeightConfig.desktop : imageHeightConfig === null || imageHeightConfig === void 0 ? void 0 : imageHeightConfig.mobile
    }),
    contentContainer: {
      padding: tokens.spacing.SPACING_16
    }
  });
};